import { HeaderBar } from "routes/schedule/compare/header-bar"
import { registerComparitor } from "routes/schedule/compare/register-comparitor"
import { TextDifference } from "routes/schedule/compare/text-difference"
import { FEATURE_FLAG_AUTHORING } from "authoring/routes/authoring.runtime"
import { isEnabled } from "lib/@components/feature"

registerComparitor(
    "code",
    () => (
        <HeaderBar label="Details">
            <TextDifference path="code" label="code" />
        </HeaderBar>
    ),
    () => isEnabled(FEATURE_FLAG_AUTHORING) && window.location.pathname.includes("authoring")
)

registerComparitor(
    "unitOfMeasure",
    renderUnitOfMeasureDifference,
    () => isEnabled(FEATURE_FLAG_AUTHORING) && window.location.pathname.includes("authoring")
)

function renderUnitOfMeasureDifference({ v1, v2 }) {
    if (v1 === undefined && v2 === undefined) return null

    return (
        <HeaderBar label="Details">
            <TextDifference path="unitOfMeasure" label="Unit of Measure" />
        </HeaderBar>
    )
}
